import { defineAsyncComponent } from 'vue';
import AppConfirmationPopover from '@/features/App/AppConfirmationPopover.vue';
import {
	ResourcePlanningActionShortcut,
	ResourcePlanningAddMember,
	ResourcePlanningIcon,
	ResourcePlanningAvatar,
	ResourcePlanningPlaceholderIcon,
	ResourcePlanningCollapseUsersShortcut,
} from './components/ResourcePlanning';
import { ResourcePlanningBookingModal } from './components/ResourcePlanningBookingModal';
import { ResourcePlanningUserSelect } from './components/ResourcePlanningUserSelect';
import { ResourcePlanningProjectsPopover } from './components/ResourcePlanningProjectsPopover';
import { ResourcePlanningPortfolioAddToProject } from './components/ResourcePlanningPortfolio';
import { TimeOffListPopover } from '@/features/Calendar';
export { ResourcePlanningChart } from './components/ResourcePlanning';
export * from './types';
export { useResourcePlanningStore } from './store';

export const resourcePlanningComponents = {
	ResourcePlanningAvatar,
	ResourcePlanningIcon,
	ResourcePlanningPlaceholderIcon,
	ResourcePlanningActionShortcut,
	ResourcePlanningAddMember,
	ResourcePlanningCollapseUsersShortcut,
	ResourcePlanningBookingModal,
	ResourcePlanningUserSelect,
	AppConfirmationPopover,
	ResourcePlanningProjectsPopover,
	ResourcePlanningPortfolioAddToProject,
	TimeOffListPopover,
} as const;

export const resourcePlanningMicroFrontends = {
	ResourcePlanningPortfolio: defineAsyncComponent(
		() =>
			import('./components/ResourcePlanningPortfolio/ResourcePlanningPortfolio.vue')
	),
	RoleReplacementMessage: defineAsyncComponent(
		() =>
			import('./components/RoleReplacementMessage/RoleReplacementMessage.vue')
	),
};
